import { render, staticRenderFns } from "./pageComm.vue?vue&type=template&id=6ac93adb&scoped=true"
import script from "./pageComm.vue?vue&type=script&lang=js"
export * from "./pageComm.vue?vue&type=script&lang=js"
import style0 from "./pageComm.vue?vue&type=style&index=0&id=6ac93adb&prod&lang=scss&rel=stylesheet%2Fscss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ac93adb",
  null
  
)

export default component.exports